import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  Component,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-long-wait-dialog',
  imports: [CommonModule, A11yModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './long-wait-dialog.component.html',
  styleUrl: './long-wait-dialog.component.scss',
})
export class LongWaitDialogComponent {
  @Output() acknowledge = new EventEmitter<void>();

  readonly titleId = 'long-wait-dialog-title';
  readonly descriptionId = 'long-wait-dialog-description';

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    event.preventDefault();
    this.onAcknowledge();
  }

  onAcknowledge(): void {
    this.acknowledge.emit();
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onAcknowledge();
    }
  }
}
